<template>
  <div>
    <v-card>
      <v-card-text>
        <v-autocomplete
          :items="miembros"
          :filter="customFilter"
          color="indigo"
          :loading="cargando"
          @update:search-input="buscarMiembros"
          item-text="nombre"
          item-value="id"
          clearable
          label="Buscar por nombre, matrícula o teléfono"
          return-object
          v-model="miembroSeleccionado"
          :search-input.sync="busqueda"
          :no-data-text="'No se encontraron resultados'"
        >
          <template v-slot:no-data>
            <div class="px-4">
              No se encontraron resultados con "{{ busqueda }}"
            </div>
          </template>
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-avatar>
                <img :src="urlImagen(data.item.imagen)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.nombre"></v-list-item-title>
                <v-list-item-subtitle>
                  <div>Matrícula: {{ data.item.matricula }}</div>
                  <div>Teléfono: {{ data.item.telefono }}</div>
                  <div v-if="data.item.membresia">Membresía: {{ data.item.membresia }}</div>
                  <div>Estado: 
                    <v-chip
                      small
                      :color="data.item.estado === 'ACTIVO' ? 'success' : 'error'"
                      text-color="white"
                    >
                      {{ data.item.estado }}
                    </v-chip>
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "BusquedaMiembro",

  data: () => ({
    cargando: false, 
    busqueda: "",
    miembros: [],
    miembroSeleccionado: {},
  }),

  methods: {
    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    buscarMiembros(valor) {
      if (valor && valor.length > 0) {
        let payload = {
          metodo: "obtener_nombre_matricula",
          busqueda: valor,
        };
        this.cargando = true;
        HttpService.obtenerConDatos(payload, "miembros.php").then(
          (resultados) => {
            this.miembros = resultados;
            this.cargando = false;
          }
        );
      } else {
        this.miembros = [];
      }
    },

    customFilter(item, queryText, itemText) {
      const textOne = item.nombre.toLowerCase();
      const textTwo = item.matricula.toString();
      const textThree = item.telefono.toString();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || 
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1
      );
    },
  },

  watch: {
    miembroSeleccionado(miembro){
      this.$emit("seleccionado", miembro);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Miembros/BusquedaMiembro.vue